import PLP from '../sections/PLP';

new PLP().init();
